const financeRoutes = [
    {
        path: '/onlineRecharge',
        name: 'onlineRecharge',
        component: () => import('../../views/finance/OnlineRecharge.vue'),
        meta: { title: '在线充值' }
    },
    {
        path: '/storedValueRecords',
        name: 'storedValueRecords',
        component: () => import('../../views/finance/StoredValueRecords.vue'),
        meta: { title: '储值记录' }
    },
    {
        path: '/creditLimitManagement',
        name: 'creditLimitManagement',
        component: () => import('../../views/finance/CreditLimitManagement.vue'),
        meta: { title: '信用额度管理' }
    }
]

export default financeRoutes

